{
  "de": {
    "baseChip": {
      "states": {
        "included": "eingeschlossen",
        "excluded": "ausgeschlossen"
      }
    }
  }
}
